import _actions_setAddField from './_actions/setAddField.js'
import _actions_set from './_actions/set.js'
import _mutations_set_filter from './_mutations/set/filter.js'
import _mutations_set_data from './_mutations/set/data.js'
import _mutations_filter_set from './_mutations/filter/set.js'
import _mutations_filter_remove from './_mutations/filter/remove.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        filter_remove: _mutations_filter_remove,
        filter_set: _mutations_filter_set,
        set_data: _mutations_set_data,
        set_filter: _mutations_set_filter,
    },
    actions:{
        set: _actions_set,
        setAddField: _actions_setAddField,
    },
}